<template>
  <div>
    <BimContainer>
      <BimRow justify="center">
        <BimCol v-bind="sizes" class="mx-auto">
          <slot></slot>
        </BimCol>
      </BimRow>
    </BimContainer>
  </div>
</template>

<script>
import BimCol from '@bimlib/components/bimCol'
import BimRow from '@bimlib/components/bimRow'
import BimContainer from '@bimlib/components/bimContainer'
export default {
  name: 'BlockWrapper',
  components: {
    BimCol,
    BimRow,
    BimContainer,
  },
  props: {
    small: Boolean
  },
  computed: {
    sizes() {
      if (this.small) {
        return {
          xxl: 8,
          xl: 10,
          sm: 12,
        }
      }
      return {
        xxl: 10,
        xl: 11,
        sm: 12,
      }
    }
  }
}
</script>
